import * as v from "valibot";
import { rpcContract } from "../rpc";

/**
 * Disable one-time purchase for specific content
 * Archives Stripe product, marks inactive in database
 * Existing purchasers keep access
 */
export const disableOneTimePurchaseRpcContract = rpcContract({
  name: "disable-one-time-purchase",
  paramsSchema: v.object({
    contentType: v.picklist(["post", "link"]),
    contentId: v.string(),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    productId: v.string(),
  }),
});

export type DisableOneTimePurchaseParams = v.InferOutput<(typeof disableOneTimePurchaseRpcContract)["paramsSchema"]>;
export type DisableOneTimePurchaseResult = v.InferOutput<(typeof disableOneTimePurchaseRpcContract)["resultSchema"]>;
